import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store';
import { DocumentState } from '@/store/modules/document/index';
import {
  ADD_DOCUMENT,
  DELETE_DOCUMENT,
  DOWNLOAD_DOCUMENT,
  GET_DOCUMENT_LIST,
  REMOVE_DIRTY_DOCUMENT,
  REMOVE_DOCUMENT,
  SET_DOCUMENTS,
  SET_DOCUMENTS_ERRORS,
  SET_LOADING,
  SET_MISSING_DOCUMENTS,
  SET_REMOVE_MISSING_DOCUMENT_FLAG,
  UPLOAD_CLICKED,
} from '@/types/documents.types';
import { finalize } from 'rxjs/operators';
import DocumentService from '@/services/document.service';
import { Document } from '@/models/form/Documents.model';
import { RequestPayload } from '@/models/base/RequestPayload';
import { Utils } from '@/globals/Utils';
import { CHECK_MISSING_DOCUMENTS, FORM_ROOT } from '@/types/form.types';

export const documentService = new DocumentService();

export const actions: ActionTree<DocumentState, RootState> = {

  [UPLOAD_CLICKED]: (
    { commit, dispatch, state, rootGetters }: ActionContext<DocumentState, RootState>,
    { requestBody }: RequestPayload,
  ) => {
    const newDoc: Document = {
      docName: requestBody.inputFile.name,
      mimeType: requestBody.inputFile.type,
      docType: requestBody.docType.slice(3),
      name: requestBody.inputFile.name,
    };
    commit(ADD_DOCUMENT, newDoc);
    commit(SET_LOADING, true);
    commit(SET_DOCUMENTS_ERRORS, []);
    documentService.uploadDocument(requestBody.inputFile, requestBody.docType, requestBody.formId)
      .pipe(
        finalize(() => {
          commit(REMOVE_DIRTY_DOCUMENT);
          commit(SET_LOADING, false);
          if (state.uploadMissingDocumentsFlag) {
            commit(SET_MISSING_DOCUMENTS, []);
            dispatch(FORM_ROOT + CHECK_MISSING_DOCUMENTS, null, { root: true })
              .then(res => res)
              .catch(err => err);
          }
        }),
      )
      .subscribe(
        (data: any) => {


          commit(REMOVE_DIRTY_DOCUMENT);
          const doc: Document = {
            docName: requestBody.inputFile.name,
            mimeType: requestBody.inputFile.type,
            docType: requestBody.docType.slice(3),
            name: requestBody.inputFile.name,
            docId: data.docKey,
          };
          commit(ADD_DOCUMENT, doc);

        },
        (error: any) => {
          commit(SET_DOCUMENTS_ERRORS, error.messages);
        },
      );
  },

  [DELETE_DOCUMENT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<DocumentState, RootState>,
    docId: number,
  ) => {
    commit(SET_LOADING, true);
    documentService.deleteDocument(docId)
      .pipe(
        finalize(() => {
          if (state.removeMissingDocumentsFlag) {
            dispatch(FORM_ROOT + CHECK_MISSING_DOCUMENTS, null , { root: true })
              .then(res => res)
              .catch(err => err);
            commit(SET_REMOVE_MISSING_DOCUMENT_FLAG, false);
          }
          commit(SET_LOADING, false);
        }),
      )
      .subscribe(
        () => {
          commit(REMOVE_DOCUMENT, docId);
        },
        (error: any) => {
          commit(SET_DOCUMENTS_ERRORS, error.messages);
        },
      );
  },

  [DOWNLOAD_DOCUMENT]: (
    { commit, dispatch, state, rootGetters }: ActionContext<DocumentState, RootState>,
    { requestBody }: RequestPayload,
  ) => {
    commit(SET_LOADING, true);
    documentService.getDocumentContent(requestBody.docId)
      .pipe(
        finalize(() => commit(SET_LOADING, false)),
      )
      .subscribe(
        data => {
          Utils.downloadBase64File(data.body, requestBody.docName, requestBody.fileType);
        },
        (error: any) => {
          commit(SET_DOCUMENTS_ERRORS, error.messages);
        },
      );
  },

  [GET_DOCUMENT_LIST]: (
    { commit, dispatch, state, rootGetters }: ActionContext<DocumentState, RootState>,
    formId: number,
  ) => {
    documentService.getFormDocumentsList(formId)
      .subscribe(
        data => {
          commit(SET_DOCUMENTS, data.documentList);
        },
        (error: any) => {
          commit(SET_DOCUMENTS_ERRORS, error.messages);
        },
      );
  },

};
